import { Modal, Box, Slide, Typography, Grid, Divider } from "@mui/material"
import { BranchOrderItemRead } from "../../../global/API"
import { useState, useEffect } from "react"
import CloseIcon from '@mui/icons-material/Close';

export const OrderDetails = ({ open, setOpen, orderDetails }) => {

    const [orderItems, setOrderItems] = useState([])

    const ReadBranchOrderItem = async () => {
        if (!orderDetails?.id) return

        const qsp = { order_id: orderDetails.id }
        const res = await BranchOrderItemRead(qsp)

        if (res) setOrderItems(res)
    }

    useEffect(() => {
        if (open) ReadBranchOrderItem()
        //eslint-disable-next-line
    }, [open])

    const formatDate = (date) => {
        const d = new Date(date)
        return d.toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        })
    }

    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <Slide in={open} direction="up">
                <Box
                    sx={{
                        width: 600,
                        bgcolor: "#fff",
                        p: 3,
                        mx: "auto",
                        mt: "10%",
                        borderRadius: 2
                    }}
                >

                    {/* HEADER */}
                    <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                        <Typography variant="h6" fontWeight="bold">
                            Order Details
                        </Typography>
                        <CloseIcon onClick={() => setOpen(false)} sx={{color: "red"}}/>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    {/* ORDER INFO */}
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <Typography variant="body2">
                                <b>Order No:</b> {orderDetails?.series_num}
                            </Typography>
                        </Grid>

                        <Grid item xs={6}>
                            <Typography variant="body2">
                                <b>Branch:</b> {orderDetails?.name}
                            </Typography>
                        </Grid>

                        <Grid item xs={6}>
                            <Typography variant="body2">
                                <b>Staff:</b> {orderDetails?.first_name} {orderDetails?.last_name}
                            </Typography>
                        </Grid>

                        <Grid item xs={6}>
                            <Typography variant="body2">
                                <b>Date:</b> {formatDate(orderDetails?.created_at)}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Divider sx={{ my: 2 }} />

                    {/* ITEMS HEADER */}
                    <Grid container sx={{ fontWeight: "bold", mb: 1 }}>
                        <Grid item xs={6}>Product</Grid>
                        <Grid item xs={2}>Qty</Grid>
                        <Grid item xs={4} textAlign="right">Amount</Grid>
                    </Grid>

                    {/* ITEMS */}
                    {orderItems.map((item) => (
                        <Grid container key={item.id} sx={{ mb: 1 }}>
                            <Grid item xs={6}>
                                {item.product_name}
                            </Grid>

                            <Grid item xs={2}>
                                {item.quantity}
                            </Grid>

                            <Grid item xs={4} textAlign="right">
                                ₱{item.amount}
                            </Grid>
                        </Grid>
                    ))}

                    <Divider sx={{ my: 2 }} />

                    {/* TOTAL */}
                    <Grid container>
                        <Grid item xs={8}>
                            <Typography fontWeight="bold">
                                Total Sales
                            </Typography>
                        </Grid>

                        <Grid item xs={4} textAlign="right">
                            <Typography fontWeight="bold">
                                ₱{orderDetails?.total_sales}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={8}>
                            <Typography fontWeight="bold">
                                Cash Received
                            </Typography>
                        </Grid>

                        <Grid item xs={4} textAlign="right">
                            <Typography fontWeight="bold">
                                ₱{orderDetails?.cash_received}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Divider sx={{ my: 2 }} />
                    
                    <Grid container>
                        <Grid item xs={8}>
                            <Typography fontWeight="bold">
                                Change
                            </Typography>
                        </Grid>

                        <Grid item xs={4} textAlign="right">
                            <Typography fontWeight="bold">
                                ₱{parseFloat(orderDetails?.cash_received) - parseFloat(orderDetails?.total_sales)}
                            </Typography>
                        </Grid>
                    </Grid>

                </Box>
            </Slide>
        </Modal>
    )
}